import React from 'react';

const LoadingIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-loading" />
    </div>
  );
};

export default LoadingIcon;
